module.exports = __webpack_public_path__ + "static/media/JC_inset_129.2a6e4e3e.gif";